import { Link, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "~/components/button";
import { useSearch } from "~/hooks/search/use-search";
import {
  FilterType,
  SearchFilterComparisonOperator,
} from "~/hooks/search/types";
import { TicketCategory } from "~/integrations/zendesk";
import { ActionCard } from "~/components/card/action-card";
import { Text } from "~/components/text";

const KEYWORD_COUNT = 5;

const KEYWORDS_QUERY_LESS_THAN = {
  filters: {
    keywordCount: {
      value: KEYWORD_COUNT,
      comparisonOperator: SearchFilterComparisonOperator.LESS,
      type: FilterType.NUMERIC,
    },
  },
} as const;

export const BacklistLinks = () => {
  const { data } = useSearch(KEYWORDS_QUERY_LESS_THAN);
  const { t } = useTranslation(["home"]);
  const navigate = useNavigate();

  const handleBookNavigate = () => {
    navigate({
      to: "/books",
      search: { filter: `keywordCount.lt.${KEYWORD_COUNT}` },
    });
  };

  return (
    <div className="space-y-4">
      <Text as="h2" variant="heading">
        {t("home:backlist.links.title")}
      </Text>

      <div className="grid lg:grid-cols-[auto_1fr] gap-4 grid-rows-[90px]">
        <ActionCard
          title={
            data?.found === undefined
              ? ""
              : t("home:backlist.keywords.title", {
                  count: data?.found ?? 0,
                })
          }
          isLoading={data?.found === undefined}
          subtitle={t("home:backlist.keywords.subtitle", {
            count: KEYWORD_COUNT,
          })}
          iconName="square-stack"
          onClick={handleBookNavigate}
          iconWrapperClassName="bg-[#FDF0F6]"
          iconClassName="text-[#F32C69]"
        >
          <ActionCard.Action
            iconName="arrow-right"
            label={t("home:backlist.keywords.actions.viewBooks")}
            onClick={handleBookNavigate}
            testId="backlist-keywords-action"
          />
        </ActionCard>

        <div className="flex-1 bg-secondary-25 rounded-xl flex items-center justify-center px-6 py-3 space-x-3">
          <div>🚀</div>
          <div className="text-sm">
            <Text as="span" variant="label">
              {t("home:backlist.comingSoon")}
            </Text>
          </div>
          <Link
            to="/contact-us"
            search={{
              ticketCategory: TicketCategory.feature_request,
              message: t("home:backlist.featureRequestMessage"),
            }}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center"
          >
            <Button variant="tertiary" size="small">
              {t("general:contactUs")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
